import React from "react";
import "./ui.css";

/**
 * The scope Ed's Tailwind works inside. Every utility from ./tailwind.config.js
 * is emitted as `.shelv-ui .<class>`, so a ui/ component only takes its styles
 * under an element carrying `shelv-ui`. ShelvShell and ShelvEntry already wrap
 * their pages; use this for any other page that renders ui/ components.
 */
export function ShelvUI({ children, className, ...rest }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={className ? `shelv-ui ${className}` : "shelv-ui"} {...rest}>{children}</div>;
}

/** Class name for a root element that should own the scope itself. */
export const SHELV_UI_SCOPE = "shelv-ui";
